import { useContextState } from "../../../../hooks/theme"

export const useStyles = () => {
  const { colors: color } = useContextState()
  return {
    tab2: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    },
    edit: {
      color: color.color1,
      '& .MuiSvgIcon-root': {
        fontSize: '2rem'
      }
    },
    container: {
      position: 'relative',
      padding: '50px 50px 50px 2px',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '& .table-container': {
        // maxHeight: 'calc(100vh - 300px)',
        // height: 'calc(100vh - 300px)',
      },
      '& .MuiTableCell-root.MuiTableCell-root .MuiBox-root': {
        justifyContent: 'start',
        '& .MuiFormControlLabel-root': {
          marginLeft: '0px',
        },
      },
    },
    userSelected: ({ haveUser }: { haveUser: boolean }) => ({
      color: haveUser ? color.color1 : color.color13
    }),
    notFound: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      "& .notFoundData": {
        fontSize: '20px',
        color: color.color13
      }
    },
    add: {
      '& .MuiSvgIcon-root': {
        fontSize: "2rem",
      },
      color: color.color4
    },
    modal: {
      position: 'relative',
      maxWidth: '1200px',
      width: '95vw',
      height: 'calc(90vh)',
      maxHeight: '800px',
      overflowY: 'auto'
    },
    separator: {
      borderRight: `2px solid ${color.color13}88`
    },
    modalContent: ({ open }: { open: boolean }) => ({
    }),
    content: {
      padding: '0 20px',
      paddingTop: '20px',
    },
    contentRight: {
      overflowY: 'auto',
      maxHeight: 'calc(90vh - 110px)'
    },
    createTitle: {
      // fontSize: '1.4rem',
      paddingBottom: '0px',
      lineHeight: '1',
      padding: '20px 20px 0',
    },
    description: {
      fontSize: '.8rem',
      padding: '0 20px',
      width: '100%',
      '& span': {
        color: color.color16
      }
    },
    permissionTable: (payload: { loading: boolean }) => ({
      padding: '20px',
      paddingBottom: '0px',
      ...!!payload.loading && {
        position: 'relative',
        top: '25%'
      }
    }),
    centerTitle: {
      height: '90px',
      display: 'flex',
      width: '100%',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    headerTable: { fontSize: '.8rem', marginBottom: '10px' },
    separatorHeader: {
      paddingBottom: '20px',
      borderBottom: `1px solid ${color.color13}88`
    },
    footerBtn: {
      marginTop: "20px",
      paddingTop: '0px',
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: '0 20px 20px',
    },
    containerLoader: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    checksTypes: ({ border }: { border: boolean }) => ({
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'start',
      width: '100%',
      height: 'fit-content',
      ...border && {
        borderLeft: `1px solid ${color.color13}`,
        '&:last-child': {
          borderRight: `1px solid ${color.color13}`,
        }
      }
    }),
    containerChecks: {
      padding: '35px 20px 0',
    },
    checksChildren: (payload?: { jc: string }) => ({
      width: '100%',
      display: 'flex',
      justifyContent: payload?.jc ?? 'start',
      columnGap: '40px',
      '& .MuiTypography-root': {
        width: '100%',
        textAlign: 'center',
        color: color.color5,
        fontSize: '12px',
      },
    }),
    label: {
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      /* justifyContent: 'space-around', */
      '& .MuiTypography-root': {
        fontSize: '12px',
        fontWeight: '500',
        /* color: color.color9, */
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '12px',
        fontWeight: '400',
        color: color.color5,
      }
    },
    close: {
      position: 'absolute',
      top: '5px',
      right: "5px"
    },
    headerCell: {
      padding: '16px 0px',
      // borderLeft: `1px solid ${color.color13}`,
      '&.header-cell-color': {
        // position: 'absolute',
        background: color.color5,
      },
      '&.MuiTableCell-root .MuiBox-root.MuiBox-root': {
        // bottom: 0,
        justifyContent: 'start',
        // width: '100%',
        '& .MuiTableSortLabel-root': {
          width: '100%',
        }
      }
    },
    delete: {
      /* position: "relative",
      bottom: '-15px',
      left: '-5px', */
      fontSize: '14px',
      /* '& .MuiSvgIcon-root': {
        fontSize: '1.2rem',
      }, */
      color: 'white',
      marginRight: '10px',
      '&.MuiButtonBase-root':{
        backgroundColor: color.color31,
        /* transition: 'all 0.3s ease', */
        '&:hover': { 
          fontSize: '13px',
          transform: 'scale(0.99)', 
        },
      }
    },
    userAmount: {
      fontSize: '35px',
      fontWeight: '500'
    },
    questionnaireAccess: {
      fontSize: '14px',
      fontWeight: '500'
    },
    header: {
      '&.MuiTableCell-head': {
        minWidth: '100px',
      },
      '&.MuiTableCell-root.MuiTableCell-root': {
        vertialAlign: 'middle',
      },
    },
    title: {
      fontSize: '20px',
      fontWeight: '500',
    },
    subtitle: {
      color: color.color19,
      fontSize: '.8rem'
    },
    flex: {
      display: 'flex',
      alignItems: 'center'
    },
    titleQ: (payload?: { top?: number; left?: number }) => ({
      // position: 'absolute',
      // top: `${payload?.top ?? -15}px`,
      // left: `${payload?.left ?? 40}%`,
      width: '100%',
      fontSize: '16px',
      color: color.color5,
      background: color.color9,
      textAlign: 'center'
    }),
    detailChecks: (payload?: { bottom?: number }) => ({
      // position: 'relative',
      // bottom: payload?.bottom ?? '-20px',
      // border: `2px solid ${color.color9}`,
      // borderTopRightRadius: '8px',
      // borderTopLeftRadius: '8px',
      padding: '8px 6px',
      columnGap: '30px',
      display: 'flex',
      width: '100%',
      '&.MuiTableCell-root': {
        justifyContent: 'space-between'
      }
    }),
    containerTabList: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      marginTop: 3
    },
    goBack: {
      display: 'flex',
      justifyContent: 'flex-start',
      '& .MuiSvgIcon-root': {
        fontSize: '1.4rem',
        color: color.color4,
      },
    },
    tabContext: {
      padding: '0px 2px'
    },
    tabList: {
      position: 'relative',
      bottom: '-10px',
      borderBottom: 'none',
      '& .MuiTabs-indicator': {
        height: '0px'
      },
      '& .MuiTabs-flexContainer': {
        justifyContent: 'end',
        gap: 1,
        padding: '1px 2px 0px',
        '& .Mui-selected': {
          color: color.primary,
          background: color.color5,
          '-webkit-box-shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
          '-moz-box-shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
          'box- shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
        }
      }
    },
    alignItems: {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: 2,
      '& .MuiTypography-root': {
        fontSize: '14px'
      }
    },
    buttonsContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .back': {
        width: '80px',
        height: '36px',
        textTransform: 'uppercase',
      },
      '& .next': {
        borderRadius: '4px',
        textTransform: 'uppercase',
      },
    },
    titleContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '10px',
    },
    arrow: {
      display: 'flex',
      alignItems: 'center'
    },
    headerSecondTab: {
      display: 'flex', 
      width: '100%', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom:'20px'
    }
  }
}
